import { Map } from 'immutable';
import { createSelector } from 'reselect';

const selectModals = (state) => state.get('modal', Map());

const makeSelectOpenModals = () =>
  createSelector(selectModals, (state) => state.filter((item) => item.get('isOpen')));

const makeSelectModal = (modalId) => createSelector(selectModals, (state) => state.get(modalId));

const makeSelectModalProps = (modalId) =>
  createSelector(selectModals, (state) => state.getIn([modalId, 'props']));

export { selectModals, makeSelectModal, makeSelectOpenModals, makeSelectModalProps };
